
export default [
    {
        path: 'basicResources',
        name: { list: ['产业大数据', '资源', '资源配置', '基础资源'] },
        component: () => import('@/views/bigDataSetup/basicResources.vue')
    },
    {
        path: 'resourceDistribution',
        name: { list: ['产业大数据', '资源', '资源配置', '基础资源分布'] },
        component: () => import('@/views/bigDataSetup/resourceDistribution.vue')
    },
    {
        path: 'resourcePrice',
        name: { list: ['产业大数据', '资源', '资源配置', '山楂收货价格'] },
        component: () => import('@/views/bigDataSetup/resourcePrice.vue')
    }
    
]